import {Component, OnDestroy, OnInit} from '@angular/core';
import {BadgesService} from "../../services/badges.service";
import {BadgeActivity} from "../../services/models/badges/BadgeActivity";
import {EventService} from "../../services/event.service";

@Component({
  selector: 'app-badges',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.scss'],
})
export class BadgesComponent implements OnInit, OnDestroy {
  activities = new Array<BadgeActivity>;
  constructor(
    private badgesService: BadgesService,
    private eventService: EventService
  ) { }

  ngOnInit() {
    this.refreshBadges();
    this.eventService.activityFinished.subscribe(() => this.refreshBadges());
  }
  refreshBadges() {
    this.badgesService.getList()
      .then(r => {
        this.activities = new Array<BadgeActivity>();
        for (let activitiesKey in r.activities) {
          if(r.activities[activitiesKey].isVisibleInMain) {
            this.activities.push(r.activities[activitiesKey])
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
  }

  ngOnDestroy(): void {

  }
}
